import React, { useEffect, useState } from "react";
import Masonry from 'react-masonry-css';

const renderHTML = (escapedHTML) => React.createElement("div", { dangerouslySetInnerHTML: { __html: escapedHTML } });

const Residents = () => {
  const teamData = {
    "team": [
      {
        "name": "Dogman",
        "role": "Owner / Presenter",
        "image": "images/team/dogman.jpg",
        "bio": "Lover of music, dogs, motorbikes and chocolate (not necessarily in that order). Musical taste depends on mood."
      },
      {
        "name": "Nikki",
        "role": "Owner / Presenter",
        "image": "images/team/nikki.jpg",
        "bio": "When Nikki relaxes she likes to paint nails, listen to music and enjoy a gin. Favourite artist is Faithless."
      },
      {
        "name": "Mark aka Olaf",
        "role": "Presenter",
        "image": "images/team/mark.jpg",
        "bio": "RC for Area 1. New to the DJ world, loves rock old and new. His real passion is his trike."
      },
      {
        "name": "Could Be You",
        "role": "Presenter",
        "image": "images/team/could-be-you-1.jpg",
        "bio": ""
      },
      {
        "name": "Mike the Bike",
        "role": "Presenter",
        "image": "images/team/mike.jpg",
        "bio": "Mike normally teams up with Mark on Sundays. New to the DJ world with a distinctive Cornish accent."
      },
      {
        "name": "Ian Davies",
        "role": "Presenter",
        "image": "images/team/ian.jpg",
        "bio": "Ian began broadcasting in hospital radio in the mid-80s before moving to FM and AM stations in the north of England. Loves his rock."
      },
      {
        "name": "Could Be You",
        "role": "Presenter",
        "image": "images/team/could-be-you-2.jpg",
        "bio": ""
      },
      {
        "name": "Could Be You",
        "role": "Presenter",
        "image": "images/team/could-be-you-1.jpg",
        "bio": ""
      }
    ]
  };


  return (
    <div>
      <section className="team-sec">
        <div className="container-fluid ps-5 pe-5">
          <div classN ame="col-12">
            <div className="un-head wow bounceInUp">
              <h3>OUR TEAM</h3>
            </div>
          </div>
        </div>
        <div className="container-fluid ps-5 pe-5">
          <Masonry
            breakpointCols={{
              default: 4,
              1200: 3,
              992: 2,
              576: 1
            }}
            className="my-masonry-grid"
            columnClassName="my-masonry-grid_column"
          >
            {teamData.team.map((member, index) => (
              <div key={index} className="team-card">
                <div className="team-img">
                  <img src={member.image} alt={member.name} />
                </div>
                <div className="team-info">
                  <h6>{member.name}</h6>
                  <p className="team-role">{member.role}</p>
                  {member.bio && <p className="team-bio">{member.bio}</p>}
                </div>
              </div>
            ))}
          </Masonry>
        </div>
      </section>
    </div>
  );
};

export default Residents;
